import { useTranslation } from "react-i18next";
import { osPlatform } from "../../store/GlobalVarriables";

import CustomButton from "../CustomButton";

import "./style.scss";

const GlobalActionButtons = ({
  negativeAction,
  positiveAction,
  negativButtonText,
  positiveButtonText,
  disability,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="global-action-buttons-wrapper"
      style={{
        bottom: osPlatform === "iOS" ? "88px" : "72px",
      }}
    >
      <CustomButton
        color="primary"
        id="negative"
        onClick={() => {
          negativeAction();
        }}
      >
        {t(negativButtonText)}
      </CustomButton>

      <CustomButton
        id="positive"
        onClick={() => {
          positiveAction();
        }}
        disabled={disability}
      >
        {t(positiveButtonText)}
      </CustomButton>
    </div>
  );
};

export default GlobalActionButtons;
